import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { PageHemeaContainer, MainTitle, PartnerContent, Content, SideImage, MainLogo, Title, Text, Item, Icon, ItemsList, AdviseBlock, Advise, Photo, ConfirmButton } from '../page-hemea/styled';
import { ProjectListWrapper } from '../page-project-list/styled';
import YellowStar from '../../static/yellow-star.svg';
import LukoLogo from '../../static/luko.svg';
import LukoHighRes from '../../static/lukohighres.png';
const PageLuko = () => {
  const [isAccepted, setIsAccepted] = useState(false);
  const history = useHistory();

  // we don't want the user to go directly to this page. In case of change, data from users & projects must be load first.
  if (history.action === 'POP') {
    history.push('/');
    return null;
  }
  const redirectToLuko = () => {
    window.open(window.processRuntime.env?.LUKO_PARTNER_URL, '_blank');
  };
  return /*#__PURE__*/React.createElement(ProjectListWrapper, null, /*#__PURE__*/React.createElement(PageHemeaContainer, null, /*#__PURE__*/React.createElement(MainTitle, null, "Assurances"), /*#__PURE__*/React.createElement(PartnerContent, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(MainLogo, {
    src: LukoLogo,
    alt: "Luko Logo",
    isLuko: true
  }), /*#__PURE__*/React.createElement(Title, null, "Pr\xE9sentation de notre partenaire Luko"), /*#__PURE__*/React.createElement(Text, {
    noMargin: true
  }, "Luko est une n\xE9o-assurance habitation qui red\xE9finit experience de l\u2019assurance."), /*#__PURE__*/React.createElement(Text, null, "Des contrats clairs, des remboursements 2x plus rapides, un mod\xE8le 100 % digital et transparent : avec Luko, c\u2019est facile. Vous gagnez du temps et de l\u2019argent."), /*#__PURE__*/React.createElement(Text, null, "Luko propose plusieurs offres d\u2019assurances :"), /*#__PURE__*/React.createElement(ItemsList, null, /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Icon, {
    src: YellowStar,
    alt: "star-logo"
  }), "L\u2019assurance habitation"), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Icon, {
    src: YellowStar,
    alt: "star-logo"
  }), "La responsabilit\xE9 civile"), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Icon, {
    src: YellowStar,
    alt: "star-logo"
  }), "L\u2019assurance emprunteur (pr\xEAt immobilier)")), /*#__PURE__*/React.createElement(Text, null, "Luko c\u2019est des contrats clairs, des remboursements 2x plus rapides et un mod\xE8le 100 % digital et transparent."), /*#__PURE__*/React.createElement(Text, null, "Changer d\u2019assurance habitation ou d\u2019assurance emprunteur et faire de belles \xE9conomies est d\xE9sormais possible et facile avec Luko"), /*#__PURE__*/React.createElement(Title, null, "1 mois d\u2019assurance habitation offert gr\xE2ce \xE0 Algar"), /*#__PURE__*/React.createElement(Text, {
    noMargin: true
  }, "En un clic, vous serez redirig\xE9 vers Luko pour \xE9tablir votre devis et votre souscription en ligne."), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, "Cette mise en relation est gratuite"), /*#__PURE__*/React.createElement(AdviseBlock, null, /*#__PURE__*/React.createElement(Advise, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: e => setIsAccepted(e.target.checked)
  }), "En cochant cette case, j\u2019accepte \xEAtre redirig\xE9 vers le site internet de Luko via un lien affili\xE9 pour effectuer une demande de devis et / ou de souscription et profiter de l\u2019offre un mois d\u2019assurance habitation offert.")), /*#__PURE__*/React.createElement(ConfirmButton, {
    onClick: () => redirectToLuko(),
    disabled: !isAccepted
  }, "En profiter")), /*#__PURE__*/React.createElement(SideImage, {
    isLuko: true
  }, /*#__PURE__*/React.createElement(Photo, {
    src: LukoHighRes,
    alt: ""
  })))));
};
export default PageLuko;